import { Route, Routes } from "react-router-dom";
import { HomePageV2 } from "../pages/HomePageV2/Index";
import { PolicyAndSecurityPage } from "../pages/HomePageV2/PolicyAndSecurityPage";
import { Login } from "../pages/Session/Login/Index";
import { NewPassword } from "../pages/Session/NewPassword/Index";
import { SessionTemplate } from "../pages/Session/SessionTemplate/Index";

export function MainRoutes() {
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePageV2 />} />
        <Route path="/politica-e-seguranca" element={<PolicyAndSecurityPage />} />
        <Route path="/" element={<SessionTemplate />}>
          <Route path="entrar" element={<Login />} />
          <Route path="novasenha" element={<NewPassword />} />
        </Route>
      </Routes>
    </>
  );
}
